module.exports = __webpack_public_path__ + "img/Button_Next.bff849ae.png";